export default function Merged() {
  return (
    <div>
      <h4 className="list__title--order-data">Merged Order</h4>
    </div>
  )
}
